import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarFallback, AvatarImage } from '@achra/ui/avatar';
import { cn } from '@achra/ui/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from '@achra/ui/tooltip';
import type { BuilderStatus, Maybe } from '@/modules/__generated__/graphql/switchboard-generated';
import OperatorSVG from '@/modules/shared/components/svgs/operator.svg';
import { BuildersStatusChip } from '../chips/builders-status-chip';
export interface BuilderProfileProps {
  name: Maybe<string> | undefined;
  code: Maybe<string> | undefined;
  status: Maybe<BuilderStatus> | undefined;
  image: string;
  className?: string;
  isOperator?: boolean;
}
function BuilderProfile(t0) {
  const $ = _c(36);
  const {
    name,
    code,
    status,
    image,
    isOperator,
    className
  } = t0;
  const t1 = image || undefined;
  const t2 = name ?? "Wallet";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = <AvatarImage src={t1} alt={t2} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== name) {
    t4 = name?.charAt(0).toUpperCase() ?? "U";
    $[3] = name;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <AvatarFallback className="text-xs font-semibold">{t4}</AvatarFallback>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t5) {
    t6 = <Avatar className="mt-1 size-8">{t3}{t5}</Avatar>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== isOperator) {
    t7 = isOperator && <OperatorSVG className="absolute -bottom-2.5 left-1.5 z-20 size-11" />;
    $[10] = isOperator;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t6 || $[13] !== t7) {
    t8 = <div className="relative">{t6}{t7}</div>;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const avatar = t8;
  let t9;
  if ($[15] !== className) {
    t9 = cn("flex gap-4", className);
    $[15] = className;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== avatar || $[18] !== isOperator) {
    t10 = isOperator ? <Tooltip><TooltipTrigger asChild={true}>{avatar}</TooltipTrigger><TooltipContent>Operator</TooltipContent></Tooltip> : avatar;
    $[17] = avatar;
    $[18] = isOperator;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== code) {
    t11 = code?.toUpperCase();
    $[20] = code;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== name) {
    t12 = <span className="text-foreground">{name}</span>;
    $[22] = name;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t11 || $[25] !== t12) {
    t13 = <p className="text-foreground/30 line-clamp-1 w-full text-sm/5.5 font-semibold">{t11} {t12}</p>;
    $[24] = t11;
    $[25] = t12;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== status) {
    t14 = <BuildersStatusChip status={status} />;
    $[27] = status;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t13 || $[30] !== t14) {
    t15 = <div className="flex flex-col">{t13}{t14}</div>;
    $[29] = t13;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t10 || $[33] !== t15 || $[34] !== t9) {
    t16 = <div className={t9}>{t10}{t15}</div>;
    $[32] = t10;
    $[33] = t15;
    $[34] = t9;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  return t16;
}
export { BuilderProfile };